<!-- 大屏左侧 数据层 -->
<template>
  <div class="display">
    <div class="row-1">
      <img
        class="task-font-bk1-1"
        src="../../../../static/img/display-img/show_new/bg_tit_all.png"
      />
      <div class="chulirenwuzongshu" >处理任务总数</div>
    </div>
    <div class="row-2">
      <p>累计</p>
      <div class="task-num-list">
        <div class="task-item" v-for="(item, index) in summary" :key="index">
          <p>{{item.key}}</p>
          <div>
          <span class="task-num">{{item.value}}</span>
          <span class="task-num-unit">{{item.unit}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row-3">
      <img
        class="task-font-bk3-1"
        src="../../../../static/img/display-img/show_new/bg_tit_all.png"
      />
      <div class="dangqianrenwu" >粪污任务</div>
    </div>
    <div class="row-4">
      <!-- 粪污任务 -->
      <div id="pieChart">
        <p>{{tasks.total}}</p>
        <span>任务总数</span>
      </div>
      <div class="pieChartData">
        <div class="pieChartDataItem" v-for="(item, index) in tasks.data" :key="index">
          <div class="pieChartDataItemKey" >
            <div v-if="item.key == '待抽'" class="pieChartDataItemTag" style=" background-color: #5A3FFF;"></div>
            <div v-else-if="item.key == '待修'" class="pieChartDataItemTag" style=" background-color: #268AFF;"></div>
            <div v-else class="pieChartDataItemTag" style=" background-color: #3DFFDC;"></div>
            {{item.key}}
          </div>
          <div class="pieChartDataItemValue">{{item.num}}</div>
          <div class="pieChartDataItemPer">{{item.percent}}%</div>
        </div>
      </div>
    </div>
    <div class="row-5">
      <img
        class="task-font-bk5-1"
        src="../../../../static/img/display-img/show_new/bg_tit_all.png"
      />
      <div class="shujuhuizong" >任务统计</div>
    </div>
    <div class="row-6">
      <div class="chart" v-if="showChart">
        <div id="barChartData"></div>
      </div>
      <div class="chart-empty" v-else>图表暂无数据</div>
    </div>
    <div class="row-7">
      <img
        class="task-font-bk7-1"
        src="../../../../static/img/display-img/show_new/bg_tit_all.png"
      />
      <div class="yeweishuju" >液位数据</div>
    </div>
    <div class="row-8">
      <div class="mark-data-item" v-for="index of 4" :key="index">
        <div class="mark-data-item-circle">正常</div>
        <span class="mark-data-item-name">液位计</span>
      </div>
    </div>
    
  </div>
</template>
<script>
import data from './assets/data.js';
import baseEcharts from './components/BaseEcharts';
export default {
  components: {},
  name: "leftDataDisplay",
  mixins: [data],
  data() {
    return {
      objData: {},
      barChartData: "",
      barOrLineColor: [
        "#228ed8",
        "#ca8622",
        "#07c9d8",
        "#61a0a8",
        "#d48265",
        "#91c7ae",
        "#749f83",
        "#bda29a",
        "#6e7074",
        "#546570",
        "#c4ccd3",
      ], //折线和柱状的颜色
      xAndyFontColor: "#0666b9",
      showChart: true,
      unitid: "",
	    timeList: [],                       // 存放日期
            brokenLine: [],                     // 折线数据
            brokenLine1: [],                     // 折线数据
            brokenLine2: [],                     // 折线数据
            Histogram1: [],                       // 柱状图
            Histogram2: [],                     // 柱状图
    };
  },
  computed: {},
  watch: {},
  methods: {
  },
  created() {},
  mounted() {
    baseEcharts('barChartData', this.taskSum);
  },
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},

};
</script>
<style lang='scss' scoped>
p{
  margin: 0;
  // display: inline-block;
}
.display {
  width: 440px;
  height: 1078px;
  position: absolute;
}
.row-1,
.row-2,
.row-3,
.row-4,
.row-5,
.row-6,
.row-7,
.row-8 {
  position: absolute;
}
// -----图片部分------
.hand-font {
  position: absolute;
  z-index: 100;
  margin: 12px 0px 0px 16px;
  width: 1575px;
  height: 69px;
}
.hand-line {
  position: absolute;
  z-index: 100;
  margin: 80px 0px 0px 0px;
  width: 1590px;
  height: 12px;
}
.task-font-bk1-1 {
  position: absolute;
  z-index: 100;
  width: 120px;
  height: 26px;
  margin: 98px 0px 0px 17px;
}
.chulirenwuzongshu {
  position: absolute;
  z-index: 100;
  width: 148px;
  height: 23px;
  margin: 96px 0px 0px 34px;
  text-align: left;
  font-size: 20px;
  color: #FFFFFF;
}
.row-2 {
  z-index: 100;
  width: 400px;
  height: 230px;
  margin: 146px 0 0 20px;
  >p{
    height: 23px;
    font-size: 18px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 21px;
    text-align: left;
  }
  .task-num-list{
    margin-top: 10px;
    width: 400px;
    height: 196px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-content: space-between;
    .task-item{
      width: 181px;
      height: 52px;
      background-image: url(../../../../static/img/display-img/show_new/bg_task_item.png);
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      p{
        text-align: center;
        width: 70px;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 16px;
      }
      .task-num{
        width: 37px;
        height: 26px;
        font-size: 24px;
        font-weight: bold;
        color: #02DEFF;
        line-height: 28px;
      }
      .task-num-unit{
        width: 20px;
        height: 20px;
        font-size: 14px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 16px;
      }
    }
  }
}
.task-font-bk1-2 {
  position: absolute;
  z-index: 100;
  width: 148px;
  height: 26px;
  margin: 98px 0px 0px 236px;
}
.yunyingzongtishouru {
  position: absolute;
  z-index: 100;
  width: 148px;
  height: 26px;
  margin: 96px 0px 0px 262px;
}
.task-num-bk2-1 {
  position: absolute;
  z-index: 100;
  width: 205px;
  height: 46px;
  margin: 133px 0px 0px 18px;
}
.task-num-bk2-2 {
  position: absolute;
  z-index: 100;
  width: 205px;
  height: 46px;
  margin: 133px 0px 0px 236px;
}
.task-font-bk3-1 {
  position: absolute;
  z-index: 100;
  width: 110px;
  height: 26px;
  margin: 414px 0px 0px 17px;
}
.dangqianrenwu {
  position: absolute;
  z-index: 100;
  width: 148px;
  margin: 414px 0px 0px 34px;
  text-align: left;
  height: 28px;
  font-size: 20px;
  color: #FFFFFF;
  line-height: 23px;
}
.row-4{
  width: 380px;
  height: 102px;
  margin: 458px 0 0 20px;
  padding: 11px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  #pieChart{
    box-sizing: border-box;
    width: 80px;
    height: 80px;
    background-image: url(../../../../static/img/display-img/show_new/img_pie01.png);
    text-align: center;
    padding-top: 18px;
    font-size: 14px;
    >p{
      height: 26px;
      font-size: 24px;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 28px;
    }
    >span{
      width: 48px;
      height: 17px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.6);
      line-height: 14px;
    }
  }
  .pieChartData{
    width: 200px;
    height: 67px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .pieChartDataItem{
      display: flex;
      justify-content: space-between;
      .pieChartDataItemKey{
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.6);
        .pieChartDataItemTag{
          display: inline-block; 
          width: 10px; 
          height: 10px;
        }
      }
      .pieChartDataItemValue{
        width: 26px;
        height: 17px;
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 14px;
        text-align: right;
      }
      .pieChartDataItemPer{
        width: 36px;
        height: 17px;
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 14px;
        text-align: right;
      }
    }
  }
}
.task-font-bk4-1 {
  position: absolute;
  z-index: 100;
  width: 62px;
  height: 63px;
  margin: 240px 0px 0px 21px;
}
.task-font-bk4-2 {
  position: absolute;
  z-index: 100;
  width: 62px;
  height: 63px;
  margin: 240px 0px 0px 111px;
}
.task-font-bk4-3 {
  position: absolute;
  z-index: 100;
  width: 62px;
  height: 63px;
  margin: 240px 0px 0px 200px;
}
.task-font-bk4-4 {
  position: absolute;
  z-index: 100;
  width: 62px;
  height: 63px;
  margin: 240px 0px 0px 289px;
}
.task-font-bk4-5 {
  position: absolute;
  z-index: 100;
  width: 62px;
  height: 63px;
  margin: 240px 0px 0px 378px;
}
.task-font-bk5-1 {
  position: absolute;
  z-index: 100;
  width: 110px;
  height: 26px;
  margin: 593px 0px 0px 17px;
}
.shujuhuizong {
  position: absolute;
  z-index: 100;
  width: 148px;
  margin: 593px 0px 0px 34px;
  text-align: left;
  height: 28px;
  font-size: 20px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 23px;
}
.row-6{
  width: 400px;
  height: 200px;
  margin: 632px 0 0 20px;
  .chart{
    background: #0023707e;
    width: 400px;
    height: 200px;
    border-radius: 8px;
    #barChartData {
      width: 100%;
      height: 200px;
    }
  }
  .chart-empty{
    box-sizing: border-box;
    background: #002370e0;
    width: 400px;
    height: 200px;
    padding-top: 30px;
    border-radius: 8px;
    color: rgb(87, 87, 87);
    font-size: 28px;
    font-weight: bold;
    font-style: italic;
  }
}
.task-font-bk7-1{
  position: absolute;
  z-index: 100;
  width: 110px;
  height: 26px;
  margin: 874px 0px 0px 17px;
}
.yeweishuju{
  position: absolute;
  z-index: 100;
  width: 148px;
  margin: 874px 0px 0px 34px;
  text-align: left;
  height: 28px;
  font-size: 20px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 23px;
}
.row-8{
  width: 390px;
  height: 117px;
  margin: 918px 0 0 25px;
  display: flex;
  justify-content: space-between;
  .mark-data-item{
    width: 90px;
    height: 117px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .mark-data-item-circle{
      width: 74px;
      height: 74px;
      line-height: 74px;
      margin: 8px;
      text-align: center;
      font-size: 20px;
      font-weight: bold;
      color: #FEC230;
      background-image: url(../../../../static/img/display-img/show_new/bg_yewei_01.png);
    }
    .mark-data-item-name{
      height: 21px;
      font-size: 15px;
      font-weight: 400;
      text-align: center;
      color: #FFFFFF;
      line-height: 18px;
    }
  }
}
.task-summary-bk6-1 {
  position: absolute;
  z-index: 100;
  width: 128px;
  height: 56px;
  margin: 370px 0px 0px 20px;
}
.task-summary-bk6-2 {
  position: absolute;
  z-index: 100;
  width: 128px;
  height: 56px;
  margin: 370px 0px 0px 164px;
}
.task-summary-bk6-3 {
  position: absolute;
  z-index: 100;
  width: 128px;
  height: 56px;
  margin: 370px 0px 0px 310px;
}
.task-summary-bk7-1 {
  position: absolute;
  z-index: 100;
  width: 128px;
  height: 56px;
  margin: 439px 0px 0px 20px;
}
.task-summary-bk7-2 {
  position: absolute;
  z-index: 100;
  width: 128px;
  height: 56px;
  margin: 439px 0px 0px 164px;
}
.task-summary-bk7-3 {
  position: absolute;
  z-index: 100;
  width: 128px;
  height: 56px;
  margin: 439px 0px 0px 310px;
}
.task-font-bk8-1 {
  position: absolute;
  z-index: 100;
  width: 110px;
  height: 28px;
  margin: 520px 0px 0px 18px;
}
.renwutongji {
  position: absolute;
  z-index: 100;
  width: 148px;
  height: 28px;
  margin: 518px 0px 0px 8px;
}
.xiangzhen-logo {
  position: absolute;
  z-index: 100;
  width: 30px;
  height: 35px;
  margin: 383px 0px 0px 40px;
}
.cunzhuang-logo {
  position: absolute;
  z-index: 100;
  width: 30px;
  height: 30px;
  margin: 383px 0px 0px 184px;
}
.cegai-logo {
  position: absolute;
  z-index: 100;
  width: 26px;
  height: 26px;
  margin: 383px 0px 0px 330px;
}
.jumin-logo {
  position: absolute;
  z-index: 100;
  width: 28px;
  height: 28px;
  margin: 452px 0px 0px 40px;
}
.cheliang-logo {
  position: absolute;
  z-index: 100;
  width: 33px;
  height: 33px;
  margin: 445px 0px 0px 184px;
}
.zuoyerenyuan-logo {
  position: absolute;
  z-index: 100;
  width: 30px;
  height: 30px;
  margin: 451px 0px 0px 330px;
}
// ------------------
// -----数据部分------
.chulirenwuzongshu-num {
  position: absolute;
  width: 196px;
  height: 41px;
  font-size: 46px;
  font-family: DINPro;
  font-weight: bold;
  font-style: italic;
  color: #ffa200;
  line-height: 8px;
  z-index: 110;
  margin: 155px 0px 0px 33px;
  .unit-font {
    font-size: 18px;
    font-family: DINPro;
    font-weight: bold;
    font-style: italic;
  }
}
.yunyingzongtishouru-num {
  position: absolute;
  width: 196px;
  height: 41px;
  font-size: 46px;
  font-family: DINPro;
  font-weight: bold;
  font-style: italic;
  color: #ffa200;
  line-height: 8px;
  z-index: 110;
  margin: 155px 0px 0px 248px;
  .unit-font {
    position: absolute;
    font-size: 22px;
    font-family: DINPro;
    font-weight: bold;
    font-style: italic;
    margin: 10px 0px 0px -25px;
  }
}
.renwuwancheng-item-1 {
  position: absolute;
  width: 50px;
  height: 13px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #3be6ff;
  line-height: 23px;
  z-index: 110;
  margin: 260px 0px 0px 29px;
  .num {
    width: 17px;
    height: 13px;
    font-size: 19px;
    font-family: HYLingXinJ;
    font-weight: 600;
    color: #ffffff;
    line-height: 23px;
  }
  .ge {
    width: 11px;
    height: 11px;
    font-size: 11px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 23px;
  }
}
.renwuwancheng-item-2 {
  position: absolute;
  width: 50px;
  height: 13px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #3be6ff;
  line-height: 23px;
  z-index: 110;
  margin: 260px 0px 0px 120px;
  .num {
    width: 17px;
    height: 13px;
    font-size: 19px;
    font-family: HYLingXinJ;
    font-weight: 600;
    color: #ffffff;
    line-height: 23px;
  }
  .ge {
    width: 11px;
    height: 11px;
    font-size: 11px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 23px;
  }
}
.renwuwancheng-item-3 {
  position: absolute;
  width: 50px;
  height: 13px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #3be6ff;
  line-height: 23px;
  z-index: 110;
  margin: 260px 0px 0px 209px;
  .num {
    width: 17px;
    height: 13px;
    font-size: 19px;
    font-family: HYLingXinJ;
    font-weight: 600;
    color: #ffffff;
    line-height: 23px;
  }
  .ge {
    width: 11px;
    height: 11px;
    font-size: 11px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 23px;
  }
}
.renwuwancheng-item-4 {
  position: absolute;
  width: 50px;
  height: 13px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #3be6ff;
  line-height: 23px;
  z-index: 110;
  margin: 260px 0px 0px 296px;
  .num {
    width: 17px;
    height: 13px;
    font-size: 19px;
    font-family: HYLingXinJ;
    font-weight: 600;
    color: #ffffff;
    line-height: 23px;
  }
  .ge {
    width: 11px;
    height: 11px;
    font-size: 11px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 23px;
  }
}
.renwuwancheng-item-5 {
  position: absolute;
  width: 50px;
  height: 13px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #3be6ff;
  line-height: 23px;
  z-index: 110;
  margin: 260px 0px 0px 386px;
  .num {
    width: 17px;
    height: 13px;
    font-size: 19px;
    font-family: HYLingXinJ;
    font-weight: 600;
    color: #ffffff;
    line-height: 23px;
  }
  .ge {
    width: 11px;
    height: 11px;
    font-size: 11px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 23px;
  }
}
.renwuwancheng-item-Data-1{
  position: absolute;
  width: 50px;
  height: 13px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 23px;
  z-index: 110;
  margin: 305px 0 0 28px;
}
.renwuwancheng-item-Data-2{
  position: absolute;
  width: 50px;
  height: 13px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 23px;
  z-index: 110;
  margin: 305px 0 0 118px;
}
.renwuwancheng-item-Data-3{
  position: absolute;
  width: 50px;
  height: 13px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 23px;
  z-index: 110;
  margin: 305px 0 0 208px;
}
.renwuwancheng-item-Data-4{
  position: absolute;
  width: 50px;
  height: 13px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 23px;
  z-index: 110;
  margin: 305px 0 0 299px;
}
.renwuwancheng-item-Data-5{
  position: absolute;
  width: 50px;
  height: 13px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 23px;
  z-index: 110;
  margin: 305px 0 0 384px;
}
.shujuhuizong-item-1 {
  position: absolute;
  width: 50px;
  height: 17px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  z-index: 110;
  margin: 376px 0px 0px 91px;
  .num {
    width: 28px;
    height: 19px;
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ffdd00;
  }
}
.shujuhuizong-item-2 {
  position: absolute;
  width: 50px;
  height: 17px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  z-index: 110;
  margin: 376px 0px 0px 229px;
  .num {
    width: 28px;
    height: 19px;
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ffdd00;
  }
}
.shujuhuizong-item-3 {
  position: absolute;
  width: 50px;
  height: 17px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  z-index: 110;
  margin: 376px 0px 0px 375px;
  .num {
    width: 28px;
    height: 19px;
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ffdd00;
  }
}
.shujuhuizong-item-4 {
  position: absolute;
  width: 50px;
  height: 17px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  z-index: 110;
  margin: 445px 0px 0px 91px;
  .num {
    width: 28px;
    height: 19px;
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ffdd00;
  }
}
.shujuhuizong-item-5 {
  position: absolute;
  width: 50px;
  height: 17px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  z-index: 110;
  margin: 445px 0px 0px 229px;
  .num {
    width: 28px;
    height: 19px;
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ffdd00;
  }
}
.shujuhuizong-item-6 {
  position: absolute;
  width: 65px;
  height: 17px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  z-index: 110;
  margin: 445px 0px 0px 375px;
  .num {
    width: 28px;
    height: 19px;
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ffdd00;
  }
}
// ------------------

// .chart {
//   background: #0023707e;
//   width: 418px;
//   height: 311px;
//   margin: 520px 0px 0px 30px;
//   padding: 30px 0px 0px 0px;
//   border-radius: 8px;
//   #barChartData {
//     width: 100%;
//     height: 250px;
//   }
  // #chartData {
  //   width: 100%;
  //   height: 250px;
  // }
// }

.row-item-center {
  margin: 10px;
  display: flex;
  flex-direction: column;
}

//@import url(); 引入公共css类
</style>



// WEBPACK FOOTER //
// src/components/ProductDetails/mod_screen_display_show/leftDataDisplay.vue